import BaseInput from 'components/BaseInput';
import styled from 'styled-components';

export const Container = styled(BaseInput)``;
